import { observer, Provider } from 'mobx-react';
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'ui-toolkit/scss/00_styleguide/_app.scss';
import 'ui-toolkit/scss/00_styleguide/_reset.scss';
import 'ui-toolkit/scss/00_styleguide/_type.scss';
import 'ui-toolkit/scss/_hacks-and-overrides.scss';
import '../../policyUI/app.scss';
import ContainerPolicyReview from '../../policyUI/containers/ContainerPolicyReview';
import ContainerPolicyScheduleA from '../../policyUI/containers/ContainerPolicyScheduleA';
import PolicyScheduleB from '../../policyUI/containers/PolicyScheduleB';
import { RootStore } from '../../policyUI/services/RootStore';
import { useRouteMatch } from 'react-router';
import { ErrorBoundaryTW } from '../../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import { useSelectCurrentOrder } from '../../selectors/order/selectCurrentOrder';
import { PolicyContextProvider } from '../../policyUI/context/PolicyContextProvider';

const rootStore = new RootStore();

const PolicyRouter: React.FC = () => {
  const { path } = useRouteMatch();
  const { data: order } = useSelectCurrentOrder();
  return (
    <ErrorBoundaryTW>
      <Provider rootStore={rootStore}>
        <PolicyContextProvider order={order}>
          <Switch>
            <Route path={`${path}/:policyType/scheduleA/:action`} component={ContainerPolicyScheduleA} />
            <Route path={`${path}/:policyType/scheduleB/:action`} component={PolicyScheduleB} />
            <Route path={`${path}/:policyType/review/:action`} component={ContainerPolicyReview} />
          </Switch>
        </PolicyContextProvider>
      </Provider>
    </ErrorBoundaryTW>
  );
};

export default observer(PolicyRouter);
